import React from 'react';
import Grid from '../Grid';
import {
  ManageDesktopStyled,
  Article,
  Figure,
  TextBlock,
  Title,
  Description,
  Link,
  BottomNote,
  DomainDiagram
} from './styled';

const gridOverride = {
  gridTemplateRows: 'repeat(22, auto)',
  gridGap: 'initial',
  gridColumnGap: '15px'
};

const ManageDesktop = () => {
  return (
    <ManageDesktopStyled>
      <Grid style={gridOverride}>
        <TextBlock className="order-1">
          <Title>Centralized Feature Management and UX</Title>
          <Description>
            With Universal login, users are redirected to a central authorization server. Because
            authentication is taking place on the same domain as the login, credentials are not sent
            across origins, increasing security and protecting against attacks such as phishing and
            man-in-the-middle.
          </Description>
          <BottomNote>
            <h2>Features</h2>
            <p>
              For example, features such as MFA and Anomaly detection can be controlled directly
              from the dashboard for all your registered apps.{' '}
            </p>
          </BottomNote>
          <img
            src="https://cdn.auth0.com/website/universal-login/new-grid-mfa-push.svg"
            alt="MFA Push Notification"
          />
        </TextBlock>
        <Figure className="order-2">
          <img
            src="https://cdn.auth0.com/website/universal-login/new-grid-02b.svg"
            alt="Centralized Feature Management"
          />
        </Figure>
        <Figure className="order-3">
          <img
            src="https://cdn.auth0.com/website/universal-login/new-grid-03.svg"
            alt="Centralized Feature Management"
          />
        </Figure>
        <div className="order-4">
          <Figure>
            <img src="https://cdn.auth0.com/website/universal-login/new-grid-04.svg" alt="" />
          </Figure>
          <TextBlock className="order-4">
            <Title>Customize Login</Title>
            <Description>
              To customize the login page, you will have a couple of options to choose from. You can
              use Lock, a pre-built and easily configurable login widget to quickly enable a
              customized login interface.
            </Description>
          </TextBlock>
        </div>
        <img
          className="order-5"
          src="https://cdn.auth0.com/website/universal-login/new-grid-05.svg"
          alt=""
        />
      </Grid>
      <BottomNote className="sdk">
        <div className="inner-wrapper">
          <img src="https://cdn.auth0.com/website/universal-login/node_js.svg" alt="" />
          <h2>AUTH0.JS SDK</h2>
          <p>
            Alternately, you can use our full featured Auth0.js SDK if you need to build your own
            custom login UI or implement more complex authentication functionality.
          </p>
        </div>
      </BottomNote>
    </ManageDesktopStyled>
  );
};

export default ManageDesktop;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/ManageDesktop/ManageDesktop.js